import React from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {ConfirmationSettings} from "./ConfirmationSettings";
import {UserInputSettings} from "./components/user-input-settings";
import {fieldSx} from "../editMenuStyles";
import {SubSectionHeader} from "../components/EditMenuSection";

export const InputSettings = ({node, setNode, project, onUpdate, onChangeData, nodes}) => (
    <>
        <SubSectionHeader title="Parameter"/>
        <FormControl size="small" fullWidth sx={fieldSx}>
            <InputLabel id="input-entity-select-label">Parameter Entity</InputLabel>
            <Select
                labelId="input-entity-select-label"
                value={node?.data?.parameter?.entity_type}
                label="Parameter Entity"
                onChange={(e) => onChangeData("parameter", {
                    entity_type: e.target.value,
                    name: node?.data?.parameter?.name || "",
                })}
                onBlur={() => onUpdate(node)}
            >
                <MenuItem value=""><em>None</em></MenuItem>
                {project?.entities?.map(entity => (
                    <MenuItem key={entity?.id} value={entity?.name}>{entity?.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
        <TextField
            value={node?.data?.parameter?.name || ""}
            size="small"
            label="Parameter name"
            placeholder="Enter the name of the parameter"
            helperText="With this name you will be able to further access the variable."
            sx={fieldSx}
            onChange={(e) => onChangeData("parameter", {
                entity_type: node?.data?.parameter?.entity_type || "",
                name: e.target.value || "",
            })}
            onBlur={() => onUpdate(node)}
        />
        <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData}/>
        <ConfirmationSettings
            node={node} setNode={setNode} project={project} nodes={nodes}
            onChangeData={onChangeData} onUpdate={onUpdate}
        />
    </>
);
